"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFilterDialog = void 0;
const common_types_1 = require("../../common-types");
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = __importStar(require("lodash"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const dialog_1 = require("../../components/dialog/dialog");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const table_context_1 = require("./table-context");
const table_filter_dialog_item_1 = require("./table-filter-dialog-item");
exports.TableFilterDialog = (0, react_1.forwardRef)(function TableFilterDialog(props, ref) {
    const { filters, filtersState: providedFiltersState, setFiltersState: setProvidedFiltersState, classes, } = (0, react_1.useContext)(table_context_1.TableContext);
    /** Internal copy of filtersState */
    const [filtersState, setFiltersState] = (0, react_1.useState)([]);
    /**
     * Resets internal filters state.
     */
    const handleShow = (0, event_callback_hook_1.useEventCallback)(() => {
        setFiltersState(providedFiltersState);
    });
    /**
     * Saves current filters states.
     */
    const handleSave = (0, event_callback_hook_1.useEventCallback)(() => {
        const validFilterState = filtersState.map((filter) => {
            var _a;
            if (filter.enabled &&
                filter.value === null &&
                filter.operation !== common_types_1.ApiFilterOperation.IS_NULL &&
                filter.operation !== common_types_1.ApiFilterOperation.NOT_NULL &&
                !((_a = filter.filters) === null || _a === void 0 ? void 0 : _a.length)) {
                return {
                    ...filter,
                    enabled: false,
                };
            }
            return filter;
        });
        setProvidedFiltersState(validFilterState);
    });
    /**
     * Toggles the enable flag on selected filter.
     */
    const handleFilterToggle = (0, event_callback_hook_1.useEventCallback)((index) => {
        setFiltersState((filtersState) => [
            ...filtersState.slice(0, index),
            { ...filtersState[index], enabled: !filtersState[index].enabled },
            ...filtersState.slice(index + 1),
        ]);
    });
    /**
     * Changes the value of the filter.
     */
    const handleFilterValueChange = (0, event_callback_hook_1.useEventCallback)((index, value) => {
        setFiltersState((filtersState) => [
            ...filtersState.slice(0, index),
            { ...filtersState[index], value },
            ...filtersState.slice(index + 1),
        ]);
    });
    const handleFilterStateChange = (0, event_callback_hook_1.useEventCallback)((index, state) => {
        setFiltersState((filtersState) => [
            ...filtersState.slice(0, index),
            state,
            ...filtersState.slice(index + 1),
        ]);
    });
    const handleRemoveAllFilters = (0, event_callback_hook_1.useEventCallback)(() => {
        setFiltersState(filtersState.map((state) => ({
            ...state,
            value: null,
            enabled: false,
            object: null,
            filters: [],
            numberFilter: null,
        })));
    });
    /**
     * Split UI of filter dialog into columns depending on count of filters
     */
    let COLUMNS = 0;
    if (filters.length < 3) {
        COLUMNS = 1;
    }
    else if (filters.length < 5) {
        COLUMNS = 2;
    }
    else {
        COLUMNS = 3;
    }
    const groupedFilters = (0, lodash_1.groupBy)(filters, 'filterGroup');
    return (react_1.default.createElement(dialog_1.Dialog, { ref: ref, title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FILTER_DIALOG_TITLE", defaultMessage: "Nastaven\u00ED filtr\u016F" }), confirmLabel: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FILTER_DIALOG_BTN_SAVE", defaultMessage: "Ulo\u017Eit" }), onConfirm: handleSave, onShow: handleShow, actions: [
            react_1.default.createElement(Button_1.default, { key: "removeAll", variant: "outlined", onClick: handleRemoveAllFilters },
                react_1.default.createElement(Typography_1.default, { classes: { root: classes.buttonLabel } },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FILTER_DIALOG_BTN_REMOVE_ALL_FILTERS", defaultMessage: "Smazat filtry" }))),
        ] }, () => (react_1.default.createElement("div", { className: classes.filterDialogColumnsWrapper }, Object.keys(groupedFilters).map((key, idx) => {
        return (react_1.default.createElement(react_1.default.Fragment, { key: idx },
            react_1.default.createElement("div", { style: {
                    maxWidth: 900,
                    display: 'flex',
                    flexDirection: 'column',
                } }, (0, lodash_1.default)(groupedFilters[key])
                .orderBy('filterOrder')
                .chunk(COLUMNS)
                .value()
                .map((filterChunk, i) => (react_1.default.createElement("div", { key: i, className: classes.filterDialogColumn }, filterChunk.map((filter) => {
                const index = (0, lodash_1.findIndex)(filters, (f) => f.filterkey === filter.filterkey);
                const state = filtersState[index];
                return (react_1.default.createElement(table_filter_dialog_item_1.TableFilterDialogItem, { key: index, filter: filter, state: state, onToggle: () => handleFilterToggle(index), onChangeValue: (value) => handleFilterValueChange(index, value), onChangeFilterState: (state) => handleFilterStateChange(index, state) }));
            }))))),
            react_1.default.createElement("hr", { style: {
                    border: '1px solid rgba(0, 0, 0, 0.12)',
                    height: 1,
                    margin: '10px 0',
                } })));
    })))));
});
//# sourceMappingURL=table-filter-dialog.js.map